import React, { useEffect } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import moment from 'moment-jalali';

const Update = () => {

    const { id } = useParams();
    const { readGetDataById: readData } = useEntityCrud('Info/GetAnoncement?id=' + id);
    const { addData: updateData } = useEntityCrud('Info/updateAnoncement');
    const navigate = useNavigate();

    const initialValues = {
        title: '',
        content: '',
        expireDate: '',
        isActive: '1'
    };

    function convertToDate(date) {
        if (!date)
            return ""
            return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("jYYYYjMMjDD")
        }

    function convertDateToInputValue(date) {
        debugger
        if (!date) return "";

        return {
            year : parseInt(date.toString().slice(0, 4)),
            month: parseInt(date.toString().slice(4, 6)),
            day: parseInt(date.toString().slice(6, 8)),
        };
    }


    useEffect(() => {
        readData().then(({ data }) => {

            if (data.status)
                formik.setValues({
                    ...data.result,
                    isActive: data.result.isActive ? 1 : 0,
                    expireDate: convertDateToInputValue(data.result.expireDate)
                });
        });
    }, []);

    const validationSchema = Yup.object({
        title: Yup.string()
            .required(),
        content: Yup.string()
            .required()
    });

    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            id,
            title: values.title,
            content: values.content,
            isActive: values.isActive == 1,
            expireDate: values.expireDate ? convertToDate(values.expireDate) : 0
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('به روزرسانی اطلاعیه با موفقیت انجام شد');
                return navigate('/notifications');
            } else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/notifications', { replace: true });
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش اطلاعیه</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Update;